

export const BiomarkersSection = ({ biomarkers }) => {

    const midle = biomarkers?.length > 3 ? Math.ceil(biomarkers?.length / 2) : biomarkers?.length;

    const showBiomarkerItem = (key, title, value) => {
        return  <p key={key} className="m-0 text-sm d-flex">
            <span className="me-2">{ value }</span>
            <span>{ title }</span>
        </p>
    }

    return (


        <div className="d-flex flex-column px-3 biomarks-details-width">
            {biomarkers?.length > 0 &&
                <>
                    <p className="text-purple m-0 text-sm">Biomarkers (* in bursts, ** resting)</p>
                    <div className="mt-2 d-flex ">
                        <div className="w-50 pe-2">
                            { biomarkers?.slice(0, midle)?.map(b => showBiomarkerItem(b.id, b.abv, b.value)) }
                        </div>
                        <div className="w-50 ps-2">
                            { biomarkers?.slice(midle, biomarkers?.length)?.map(b => showBiomarkerItem(b.id, b.abv, b.value)) }
                        </div>
                    </div>
                </>

            }

        </div>
    )
}
